export default {
	params: [],
	validate: (value) => {
		return Stripe.card.validateCardNumber(value)
	},
	message: 'The provided number is not a valid credit card number.'
};
